<template>
  <el-dialog title="Xuất Log Hội Thoại" :visible="true" width="600px" :close-on-click-modal="false" destroy-on-close
    top="35vh" :show-close="false" @close="$emit('close')" append-to-body>
    <div class="export-chat-log">
      <div class="flex items-center space-x-2 mb-2">
        <el-date-picker class="ms-3" v-model="dateRange" type="daterange" unlink-panels range-separator="→"
          start-placeholder="Từ ngày" end-placeholder="Đến ngày" format="dd/MM/yyyy" value-format="yyyy-MM-dd"
          :picker-options="pickerOptions" size="small" />
        <div class="mx-3 my-2" style="width: 95%">
          <el-select v-model="selected" multiple filterable collapse-tags :value-key="'id'"
            :filter-method="filterMethod" style="width: 100%" placeholder="Chọn nhân viên">
            <el-option v-for="employee in filteredEmployees" :key="employee.id" :label="employee.username"
              :value="employee" />
          </el-select>
        </div>
      </div>

      <div class="mx-3" style="text-align: right; margin-top: 16px;">
        <el-button @click="$emit('close')">Hủy</el-button>
        <el-button type="primary" icon="el-icon-download" @click="exportLog"
          :disabled="!dateRange || dateRange.length !== 2">
          Xuất Log
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import * as XLSX from "xlsx";
import { HTTP } from "@/lib/http-common";

export default {
  name: "ExportChatLog",
  data() {
    return {
      dateRange: null,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      requestFilter: {},
      selected: [],
      query: '',
    };
  },
  methods: {
    filterMethod(val) {
      this.query = val;
    },
    async exportLog() {
      if (!this.dateRange || this.dateRange.length !== 2) return;

      const [startDate, endDate] = this.dateRange;

      const startTimestamp = new Date(startDate).setHours(0, 0, 0, 0);
      const endTimestamp = new Date(endDate).setHours(23, 59, 59, 999);
      try {
        const res = await HTTP.post(`/api/log-chat/export?startDate=${startTimestamp}&endDate=${endTimestamp}`, {
          employeeIds: this.selected.map(em => em.id)
        });
        if (res.data) {
          const data = res.data.map((item) => ({
            'Số điện thoại': item.phone,
            'Hội thoại': item.displayName || '',
            'Nền tảng': item.type || '',
            'Kênh': item.channel || '',
            'Nhân viên': item.employeeId?.split('_')[1] || '',
            'Thời gian': `${this.formatDateTimeShort(item.createAt)} - ${item.endAt ? this.formatDateTimeShort(item.endAt) : '...'}`
          }));

          const worksheet = XLSX.utils.json_to_sheet(data);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, 'Log Chat');

          const now = new Date();
          const fileName = `log-chat-${now.toISOString().slice(0, 10)}.xlsx`;

          XLSX.writeFile(workbook, fileName);
        }
      } catch (err) {
        console.error("Export failed", err);
        this.$message.error("Xuất log thất bại");
      }

    },
    formatDateTimeShort(time) {
      var date = new Date(time);
      var minutes = ("0" + date.getMinutes()).slice(-2);
      // var seconds = ("0" + date.getSeconds()).slice(-2);
      var hours = ("0" + date.getHours()).slice(-2);
      var day = ("0" + date.getDate()).slice(-2);
      var month = ("0" + (date.getMonth() + 1)).slice(-2);

      return (
        day +
        "/" +
        month +
        "/" +
        date.getFullYear() +
        " " +
        hours +
        ":" +
        minutes
      );
    },
  },
  computed: {
    filteredEmployees() {
      if (!this.queryEmployee) return this.app.employeeList;
      return this.app.employeeList.filter(e =>
        e.username.toLowerCase().includes(this.queryEmployee.toLowerCase())
      );
    }
  }
};
</script>

<style scoped>
.export-chat-log {
  padding: 8px 0;
}
</style>
